<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  type="email"
                  v-model="form.User.Username"
                  label="帳號"
                  :rules="formRules.email"
                  :readonly="isEdit"
                  :disabled="isEdit"
                ></v-text-field>
                <v-text-field
                  v-model="form.User.Profile.Name"
                  label="名稱"
                  :rules="formRules.name"
                  list="datalist-user-in__user-addedit-dialog"
                >
                  <template v-slot:append>
                    <datalist id="datalist-user-in__user-addedit-dialog">
                      <option
                        v-for="user in activeUsers"
                        :key="`user-datalist-${user.ID}`"
                      >{{user.Profile.Name}}</option>
                    </datalist>
                  </template>
                </v-text-field>
                <v-select
                  :items="levelOptions"
                  item-text="Name"
                  item-value="ID"
                  label="職稱"
                  v-model="form.Level"
                  :rules="formRules.level"
                ></v-select>
                <v-autocomplete
                  v-if="form.Level <= 10"
                  :items="departmentList"
                  item-text="Name"
                  item-value="ID"
                  label="部門"
                  v-model="form.DepartmentID"
                  :rules="formRules.department"
                ></v-autocomplete>

                <v-checkbox
                  v-if="form.Level==10"
                  v-model="form.User.Profile.CanViewSalary"
                  label="可檢視部門員工薪資"
                  :value="true"
                ></v-checkbox>
              </v-col>
              <!-- 薪水資訊 -->
              <v-col
                v-if="form.Level <= 10"
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="form.Salary.Amount"
                  label="底薪"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  :rules="formRules.Salary.Amount"
                ></v-text-field>
                <v-text-field
                  v-model="form.Salary.Insurance"
                  label="勞健保-員工自付額"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  :rules="formRules.Salary.Insurance"
                ></v-text-field>

              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    // form
    isFormValid: false,
    form: {},
    editedUserData: {},
    defaultForm: {
      User: {
        Username: "",
        Password: "525c8af1349f82477eefe4f1b596a678",
        Profile: {
          Name: ""
        }
      },
      DepartmentID: 0,
      Level: 1,
      Salary: {
        Amount: 0,
        Insurance: 0
      }
    },
    // options
    levelOptions: [
      { ID: 1, Name: "員工" },
      { ID: 10, Name: "主管" },
      { ID: 100, Name: "會計" },
      { ID: 1000, Name: "總經理" },
      { ID: 10000, Name: "蝦董" }
    ]
  }),
  computed: {
    formRules() {
      return {
        level: [v => !!v || "請選擇職位"],
        name: [v => !!v || "請輸入名稱"],
        email: [
          v => !!v || "請輸入Email",
          v => /.+@.+\..+/.test(v) || "Email格式錯誤",
          v =>
            !!this.form.User.ID ||
            this.users.findIndex(o => o.Username == v) < 0 ||
            "帳號已被使用"
        ],
        department: [v => !!v || "請選擇部門"],
        Salary: {
          Amount: [
            v => !!v || "請輸入底薪",
            v => parseInt(v) <= 1000000000 || "底薪不可超過10億"
          ],
          Insurance: [
            v => !!v || "請輸入勞健保-員工自付額",
            v => parseInt(v) <= 1000000000 || "勞健保不可超過10億"
          ]
        }
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增" : "編輯";
    },
    isEdit() {
      return this.editingId > -1;
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    departmentList() {
      if (this.form.DepartmentID > 0) {
        let idx = this.activeDepartmentList.findIndex(
          o => o.ID === this.form.DepartmentID
        );
        if (idx < 0) {
          var inactiveDepartment = this.$store.state.department.list.find(
            o => o.ID === this.form.DepartmentID
          );
          if (inactiveDepartment) {
            return [inactiveDepartment].concat(this.activeDepartmentList);
          }
        }
      }
      return this.activeDepartmentList;
    },
    editingIdx() {
      return this.$store.state.user.list.findIndex(o => o.ID == this.editingId);
    },
    ...mapGetters([
      "activeDepartmentList",
      "userPositions",
      "userSalaries",
      "userDepartments",
      "activeUsers",
      "users"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      if (
        this.editingId < 0 &&
        this.users.findIndex(o => o.Username == this.form.User.Username) >= 0
      ) {
        alert(`帳號已經被使用過了!`);
        return;
      }
      if (
        this.editingId < 0 &&
        this.activeUsers.findIndex(
          o => o.Profile.Name == this.form.User.Profile.Name
        ) >= 0 &&
        !window.confirm(
          `已經有一位同樣名稱的人「${this.form.User.Profile.Name}」\n確定仍要新增?`
        )
      ) {
        return;
      }

      this.form.Level = parseInt(this.form.Level) || 0;
      this.form.DepartmentID = parseInt(this.form.DepartmentID) || 0;
      if (this.form.Salary) {
        if (this.form.Salary.Amount)
          this.form.Salary.Amount = parseInt(this.form.Salary.Amount) || 0;
        if (this.form.Salary.Insurance)
          this.form.Salary.Insurance =
            parseInt(this.form.Salary.Insurance) || 0;
      }
      if (this.form.Salary.Amount > 1000000000) {
        return alert("底薪不可大於10億");
      }
      if (this.form.Salary.Insurance > 1000000000) {
        return alert("勞健保不可大於10億");
      }

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        let payload = JSON.parse(JSON.stringify(this.form));
        // 如果沒有編輯，就不用帶入數值
        if (payload.Level == this.editedUserData.Level) payload.Level = 0;
        if (payload.DepartmentID == this.editedUserData.DepartmentID)
          payload.DepartmentID = 0;
        if (
          this.form.Level > 10 ||
          (payload.Salary &&
            payload.Salary.Amount == this.editedUserData.Salary.Amount &&
            payload.Salary.Insurance == this.editedUserData.Salary.Insurance)
        )
          payload.Salary = null;

        this.$services.user
          .edit(this, payload)
          .then(res => {
            // 1 update user
            let user = res.data.result.user;
            this.$set(
              this.$store.state.user.list,
              this.editingIdx,
              res.data.result.user
            );
            // 2. update user salary
            let userSalary = res.data.result.userSalary;
            if (userSalary) {
              this.$store.state.userSalary.list.splice(0, 0, userSalary);
            }
            // 3. update user position
            let userPosition = res.data.result.userPosition;
            if (userPosition) {
              this.$store.state.userPosition.list.splice(0, 0, userPosition);
            } else {
              //window.console.error(`錯誤：新增使用者 應該要有user position`);
            }
            // 4. update user department
            let userDepartment = res.data.result.userDepartment;
            if (userDepartment) {
              this.$store.state.userDepartment.list.splice(
                0,
                0,
                userDepartment
              );
            }

            this.$emit("updated", user);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.user
          .add(this, this.form)
          .then(res => {
            // 1 update user
            let user = res.data.result.user;
            this.$store.state.user.list.splice(0, 0, user);
            // 2. update user salary
            let userSalary = res.data.result.userSalary;
            if (userSalary) {
              this.$store.state.userSalary.list.splice(0, 0, userSalary);
            }
            // 3. update user position
            let userPosition = res.data.result.userPosition;
            if (userPosition) {
              this.$store.state.userPosition.list.splice(0, 0, userPosition);
            } else {
              window.console.error(`錯誤：新增使用者 應該要有user position`);
            }
            // 4. update user department
            let userDepartment = res.data.result.userDepartment;
            if (userDepartment) {
              this.$store.state.userDepartment.list.splice(
                0,
                0,
                userDepartment
              );
            }

            this.$emit("updated", user);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      const findUserDepartment = user =>
        this.userDepartments.find(o => o.UserID == user.ID);
      const findUserSalary = user =>
        this.userSalaries.find(o => o.UserID == user.ID);
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        let user = JSON.parse(
          JSON.stringify(this.$store.state.user.list[this.editingIdx])
        );
        let salary = findUserSalary(user);
        let userDepartment = findUserDepartment(user);
        this.editedUserData = {
          User: user,
          DepartmentID: userDepartment ? userDepartment.DepartmentID : 0,
          Level: AppDataSetting.findUserLevel(this, user),
          Salary: salary ? JSON.parse(JSON.stringify(salary)) : {}
        };
        this.form = JSON.parse(JSON.stringify(this.editedUserData));
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.user.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>